import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import SubjectAttributesForm from './form';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import {
  NewPersonVM,
  AccordionSubjectAttributesVM,
} from 'shell/components/shared/sipo-person-form/new-person';

interface SubjectAttributesProps {
  isEdit?: boolean;
}

const SubjectAttributesComponent = ({ isEdit }: SubjectAttributesProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldSubjectAttributesChange = useEventCallback(
    (
      key: keyof AccordionSubjectAttributesVM,
      value: AccordionSubjectAttributesVM[keyof AccordionSubjectAttributesVM]
    ) => {
      formContext.setFieldValue('subjectAttributes', {
        ...formContext.values.subjectAttributes,
        [key]: value,
      });
    }
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-subject-attributes-content"
        id="panel-person-subject-attributes-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Attributi Soggetto</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <SubjectAttributesForm
          onChange={onFieldSubjectAttributesChange}
          values={formContext.values.subjectAttributes}
          errors={
            formContext.errors.subjectAttributes as FormikErrors<AccordionSubjectAttributesVM>
          }
          touched={
            formContext.touched
              .subjectAttributes as unknown as FormikTouched<AccordionSubjectAttributesVM>
          }
          disabled={isEdit}
        />
      </AccordionDetails>
    </Accordion>
  );
};

SubjectAttributesComponent.displayName = 'Subject Attributes component';

const SubjectAttributes = memo(SubjectAttributesComponent);

export default SubjectAttributes;
